/** @format */

import React, { useRef, useState } from "react";
import { Field, ErrorMessage } from "formik";
import Error from "./FormError";
import { useAuth } from "../context/AuthContext";
import ProgressBar from "../component/ProgressBar";
import useStorage from "../hooks/useStorage";

const FileUpload = ({ label, name, required, type, ...rest }) => {
  const star = ["*"];

  const { profilePic, setProfilePic } = useAuth();
  const { err, setErr } = useStorage(profilePic);
  const imgRef = useRef(null);
  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
  const FILE_SIZE = 1000000;

  const getFile = (e) => {
    let selected = e.target.files[0];
    if (
      selected &&
      SUPPORTED_FORMATS.includes(selected.type) &&
      selected.size <= FILE_SIZE
    ) {
      setProfilePic(selected);
      setErr(null);
    } else {
      setErr(
        "kindly select a (png, jpeg or jpg) file type with a maximum file-size of 1mb"
      );
      setProfilePic(null);
    }
  };

  return (
    <div className="form__control">
      <label htmlFor={name}>
        {label} <span className="label__required"> {required && star[0]} </span>
      </label>
      <Field name={name} type={type} {...rest}>
        {() => {
          return <input ref={imgRef} hidden type="file" onChange={getFile} />;
        }}
      </Field>
      <ErrorMessage name={name} component={Error} />
      <div
        style={{
          margin: "1rem 0",
        }}
      >
        <button
          type="button"
          className="btn"
          style={{
            background: "coral",
            // boxShadow: "0 0 3px 2px #aaa",
            fontSize: "1.2rem",
            fontWeight: "600",
            padding: "0.5rem",
            color: "#f3f3f2",
            width: "100%",
            display: "inline-block",
          }}
          onClick={() => {
            imgRef.current.click();
          }}
        >
          Upload Profile Picture
        </button>
      </div>
      {profilePic && <h3>{profilePic?.name}</h3>}
      {profilePic && <ProgressBar></ProgressBar>}
      <p style={{ color: "red" }}>{err}</p>
    </div>
  );
};

export default FileUpload;
